import{asChildPropDef as o}from"../props/index.js";import{baseCheckboxPropDefs as r}from"./base-checkbox.props.js";const e={...o,...r};export{e as checkboxGroupRootPropDefs};
//# sourceMappingURL=checkbox-group.props.js.map
